<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSearch" :autoFormCreate="(form) => {
    this.searchForm = form;
  }
    ">
        <a-row :gutter="12">
          <a-col :md="5" :sm="12">
            <a-form-item label="商品名称" fieldDecoratorId="name">
              <a-input placeholder="请输入商品名称" />
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="12">
            <a-form-item label="SKU" fieldDecoratorId="sku">
              <a-input placeholder="请输入SKU" />
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="12">
            <a-form-item label="供应商" fieldDecoratorId="supplier_id" :fieldDecoratorOptions="{
    rules: [{ required: false, message: '请选择供应商' }],
  }">
              <a-select placeholder="请选择供应商" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="d in suppliers" :key="d.id">{{
    d.name
  }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="12">
            <a-form-item label="69码" fieldDecoratorId="barcode69">
              <a-input placeholder="请输入商品69码" />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" htmlType="submit">查询</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator" v-if="isShowAddWithEdit">
      <a-button type="primary" @click="handleAdd" icon="plus">新增</a-button>
      <a-divider type="vertical" />
      <a-button @click="$refs.file.click()">
        <a-icon type="upload" />一键导入
      </a-button>
      <a-divider type="vertical" />
      <a-button @click="downloadTemplate"> <a-icon />下载模版 </a-button>
      <input type="file" ref="file" style="display: none" @change="upload" name="file" />
    </div>
    <s-table ref="table" size="middle" :columns="columns" :data="loadData">
      <template slot="pic_url" slot-scope="text">
        <span><img :src="text" style="width: 125px; height: 60px" /></span>
      </template>
      <template slot="is_featured" slot-scope="value,record">
        <a-switch :checked="value" @click="setFeatured(record)" />
      </template>
      <template slot="action" slot-scope="text, record">
        <div class="editable-row-operations">
          <!-- <a @click="showInfoList(record)">管理商品</a> -->
          <a @click="showInfoConfig(record)" v-if="!isDisabled">管理商品</a>
          <a-divider type="vertical" v-if="isShowAddWithEdit" />
          <a @click="handleEdit(record)" v-if="isShowAddWithEdit">编辑</a>
          <a-divider type="vertical" v-if="isShowAddWithEdit" />
          <a-popconfirm title="确定删除此商品吗？" @confirm="handleDelete(record)" okText="是" cancelText="否"
            v-if="isShowAddWithEdit">
            <a>删除</a>
          </a-popconfirm>
        </div>
      </template>
    </s-table>

    <a-modal :title="selectedGoods.name" :width="600" v-model="infoConfigVisable" :footer="null" @cancel="handleCancel">
      <div class="wawa-info">
        <div class="wawa-info-group">
          <h3 class="group-title">
            <a-select v-model="infoConfig.branch_id" @change="handleChangeBranch" placeholder="请选择门店"
              style="width: 240px" :disabled="isDisabled">
              <a-select-option style="width: 200px" v-for="d in branches" :key="d.id" allowClear show-search
                option-filter-prop="children">{{ d.name }}</a-select-option>
            </a-select>
          </h3>
          <div class="group-container" v-if="infoConfig.branch_id">
            <a-form layout="horizontal" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
              <a-form-item label="状态" fieldDecoratorId="is_listing"
                :fieldDecoratorOptions="{ initialValue: infoConfig.is_listing }">
                <a-radio-group name="radioGroup" v-model="infoConfig.is_listing">
                  <a-radio :value="true">上架</a-radio>
                  <a-radio :value="false">下架</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="当前库存">
                {{ infoConfig.unit_stock }}
              </a-form-item>
              <a-form-item label="调整库存" fieldDecoratorId="change_quantity" :fieldDecoratorOptions="{
    rules: [{ required: true, message: '请输入调整库存' }],
    initialValue: infoConfig.change_quantity,
  }">
                <a-input-number v-model="infoConfig.change_quantity" />
              </a-form-item>
              <a-form-item label="变动原因" fieldDecoratorId="type" :fieldDecoratorOptions="{
    rules: [{ required: true, message: '请选择变动原因' }],
    initialValue: infoConfig.type,
  }">
                <a-select placeholder="请选择类别" v-model="infoConfig.type">
                  <a-select-option :key="10">其他入库</a-select-option>
                  <a-select-option :key="11">其他出库</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="备注" fieldDecoratorId="remarks"
                :fieldDecoratorOptions="{ initialValue: infoConfig.remarks }">
                <a-input placeholder="请输入备注" v-model="infoConfig.remarks" />
              </a-form-item>
              <div class="form-tips">
                温馨提示：减少库存输入负值,备注请输入钉钉审批编号，操作库存变动需钉钉申请并通过运营经理&采购经理&财务经理同意，并且注明操作库存变动详细理由
              </div>
            </a-form>
          </div>
        </div>
        <div class="wawa-info-group">
          <h3 class="group-title right">
            <a-button type="primary" @click="handleSave" :loading="modalLoading">保存</a-button>
          </h3>
        </div>
      </div>
    </a-modal>
  </a-card>
</template>
<script>
import STable from "@/components/table/";
import { getGoodsList, deleteGoods, queryGoodsStock, setGoodsFeatured } from "@/api/goods";
import { saveInfoConfig } from "@/api/info";
import { getCategoryList } from "@/api/category";
import { getBranchList } from "@/api/branch";
import { getSupplierList } from "@/api/supplier";
import { ACCESS_TOKEN } from "@/store/mutation-types";
export default {
  name: "GoodsList",
  components: {
    STable,
  },
  data() {
    let isShowAddWithEdit = true,
      userBranchID = this.$store.getters.userInfo.branch_id,
      isDisabled = false,
      roles = this.$store.getters.roles
    console.log(roles)
    if (roles != "admin" && roles != "merchandiser") {
      isShowAddWithEdit = false
    }
    if (roles == "manager" || roles == "clerk") {
      isDisabled = true
    }
    return {
      infoConfigVisable: false, //商品管理弹窗
      selectedGoods: {}, // 点击弹窗时当前选择的行信息
      branches: [], //门店列表
      form: null,
      skus: [],
      stock: [],
      suppliers: [],
      searchForm: null, //列表查询表单
      queryParam: {}, //列表查询参数
      isShowAddWithEdit,
      userBranchID,
      isDisabled,
      modalLoading: false,
      // 表头
      columns: [
        {
          title: "图片",
          dataIndex: "pic_url",
          scopedSlots: { customRender: "pic_url" },
        },
        {
          title: "SKU",
          dataIndex: "sku",
        },
        {
          title: "名称",
          dataIndex: "name",
        },
        {
          title: "分类",
          dataIndex: "category_name",
        },
        {
          title: "供应商",
          dataIndex: "supplier_name",
        },
        {
          title: "兑换个数",
          dataIndex: "exchange_price",
          sorter: true,
          needTotal: true,
        },
        {
          title: "奥莱币个数",
          dataIndex: "outlets_price",
        },
        {
          title: "69码",
          dataIndex: "barcode69",
        },
        {
          title: "是否常用",
          dataIndex: "is_featured",
          scopedSlots: { customRender: "is_featured" },
        },
        {
          title: "操作",
          dataIndex: "action",
          width: "180px",
          scopedSlots: { customRender: "action" },
        },
      ],
      infoConfig: {}, // 配置信息
      // 加载数据方法 必须为 Promise 对象
      loadData: (params) => {
        return getGoodsList(Object.assign(params, this.queryParam)).then(
          (res) => res
        );
      },
    };
  },
  watch: {
    "infoConfig.change_quantity"(newValue, oldValue) {
      if (newValue > 0) {
        this.infoConfig.type = 10;
      } else if (newValue < 0) {
        this.infoConfig.type = 11;
      }
    }
  },
  created() {
    this.getBranchList();
    this.getSupplierList();
  },
  methods: {
    setFeatured(record) {
      setGoodsFeatured({
        id: record.id,
        is_featured: !record.is_featured,
      }).then((res) => {
        this.$refs.table.refresh();
        this.$message.success("操作成功");
      });
    },
    getSupplierList() {
      getSupplierList({ page_size: 10000 }).then((res) => {
        this.suppliers = res.list;
      });
    },
    // 获取门店
    getBranchList: function () {
      getBranchList({ page_size: 10000 }).then((res) => {
        this.branches = res.list;
      });
    },
    // 取消关闭弹窗
    handleCancel() {
      this.infoConfigVisable = false;
      this.infoConfig = {};
    },
    //库存异动记录
    gotoRecord() {
      let routerone = this.$router.resolve({ name: "ChangeRecord" });
      window.open(routerone.href, "_blank");
    },
    //列表查询
    handleSearch(e) {
      e.preventDefault();
      this.queryParam = {
        name: this.searchForm.getFieldValue("name"),
        supplier_id: this.searchForm.getFieldValue("supplier_id"),
        sku: this.searchForm.getFieldValue('sku'),
        barcode69: this.searchForm.getFieldValue('barcode69'),
      };
      this.$refs.table.refresh();
    },
    //列表重置
    handleReset() {
      this.searchForm.resetFields();
      this.queryParam = {};
      this.$refs.table.refresh();
    },
    // 添加商品
    handleAdd() {
      let routerone = this.$router.resolve({ name: "AddGoods" });
      window.open(routerone.href, "_blank");
    },
    // 编辑商品
    handleEdit(row) {
      this.$router.push({ name: "EditGoods", params: row });
      // let routertwo=this.$router.resolve({name: 'EditGoods', params: {id: row.id}})
      // window.open(routertwo.href, '_blank');
    },
    // 删除商品
    handleDelete(row) {
      deleteGoods(row.id).then((res) => {
        this.$refs.table.refresh();
        this.$message.success("删除成功");
      });
    },
    //管理商品
    showInfoConfig(row) {
      this.selectedGoods = row;
      this.infoConfigVisable = true;
      if (this.isDisabled) {
        this.infoConfig.branch_id = this.userBranchID
        this.handleChangeBranch(this.userBranchID)
      }
    },
    handleChangeBranch(branch_id) {
      console.log(branch_id, this.selectedGoods.id);
      queryGoodsStock({ goods_id: this.selectedGoods.id, branch_id })
        .then((config) => {
          const trans_config = {
            id: config.id,
            branch_id: branch_id,
            is_listing: config.is_listing,
            unit_stock: config.unit_stock,
          };
          this.infoConfig = trans_config;
        })
        .catch((res) => {
          this.infoConfig = {
            branch_id: branch_id,
            is_listing: true,
          };
        });
    },
    handleSave() {
      console.log(this.infoConfig, this.selectedGoods);
      if (!this.infoConfig.branch_id) {
        this.$message.success("请选择门店");
        return;
      }
      const infoConfig = {
        id: this.infoConfig.id,
        is_listing: this.infoConfig.is_listing,
        change_quantity: this.infoConfig.change_quantity,
        type: this.infoConfig.type,
        remarks: this.infoConfig.remarks,
      };
      this.modalLoading = true
      saveInfoConfig(infoConfig).then((res) => {
        this.$message.success("操作成功");
        this.handleChangeBranch(this.infoConfig.branch_id)
      })
        .finally(() => {
          this.modalLoading = false
        })
    },
    upload(e) {
      let files = e.target.files;
      if (files.length > 0) {
        let data = new FormData();
        data.append("file", files[0]);
        fetch("/api/admin/goods/upload", {
          method: "POST",
          body: data,
          headers: {
            Authorization: `Bearer ${this.$ls.get(ACCESS_TOKEN)}`,
          },
        }).then((res) => {
          if (res.status == 200) {
            const a = document.createElement("a");
            let filename = res.headers
              .get("content-disposition")
              .replace("attachment; filename=", "");
            res.blob().then((blob) => {
              a.href = URL.createObjectURL(blob);
              a.download = decodeURIComponent(filename);
              a.click();
              URL.revokeObjectURL(a.href);
            });
          } else if (res.status == 401) {
            res.json().then((data) => {
              //token过期或者token错误会进入此处，需要将登录状态清除并要求重新登录
              this.$message.error(`上传失败，${data.msg}`);
            });
          }
        });
      }
    },
    downloadTemplate: function () {
      window.open(
        "https://static.bianfuyule.com/%E6%89%B9%E9%87%8F%E5%88%9B%E5%BB%BA%E5%95%86%E5%93%81%E6%A8%A1%E6%9D%BFv1.xlsx",
        "_self"
      );
    },
  },
};
</script>
<style scoped>
.add-btn {
  margin-bottom: 10px;
}

.wawa-info {
  background-color: #fff;
  padding: 10px;
  border: 1px solid #e5e5e5;
}

.wawa-info-group {
  position: relative;
  padding: 10px 0;
}

.wawa-info-group .group-title {
  padding: 7px 10px;
  background-color: #f8f8f8;
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
}

.wawa-info-group .right {
  text-align: right;
}

.wawa-info-group .group-container {
  padding: 10px 10px 0;
}

.form-tips {
  padding-left: 72px;
  color: #e43930;
}
</style>
